import React, { useMemo } from "react";
import ReactECharts from "echarts-for-react";
import { getTrendChartOption } from "../chartConfigs";
const OverviewTrendChart = ({ data }) => {
  const option = useMemo(() => getTrendChartOption(data), [data]);
  return (
    <ReactECharts option={option} style={{ height: 300 }} notMerge lazyUpdate />
  );
};

export default OverviewTrendChart;
